import { Link } from "react-router-dom";
import "./adminPageHeader.css";

// One page-header implementation - title, optional subtitle, optional
// breadcrumbs, and up to two actions. Every list/detail page renders its
// heading through this instead of a bare `<h1 className="admin-page-title">`
// with its own ad hoc button next to it.
export const AdminPageHeader = ({ title, subtitle, breadcrumbs, primaryAction, secondaryAction }) => (
  <div className="admin-page-header">
    <div className="admin-page-header__text">
      {breadcrumbs && breadcrumbs.length > 0 && (
        <nav className="admin-breadcrumbs" aria-label="Breadcrumb">
          <ol>
            {breadcrumbs.map((crumb, i) => (
              <li key={i}>
                {crumb.to && i < breadcrumbs.length - 1 ? (
                  <Link to={crumb.to}>{crumb.label}</Link>
                ) : (
                  <span aria-current={i === breadcrumbs.length - 1 ? "page" : undefined}>{crumb.label}</span>
                )}
                {i < breadcrumbs.length - 1 && <span className="admin-breadcrumbs__sep">/</span>}
              </li>
            ))}
          </ol>
        </nav>
      )}
      <h1 className="admin-page-header__title">{title}</h1>
      {subtitle && <p className="admin-page-header__subtitle">{subtitle}</p>}
    </div>
    {(primaryAction || secondaryAction) && (
      <div className="admin-page-header__actions">
        {secondaryAction}
        {primaryAction}
      </div>
    )}
  </div>
);
